import { render } from "./ChatMessagesList.vue?vue&type=template&id=31d1b351&scoped=true&ts=true"
import script from "./ChatMessagesList.vue?vue&type=script&lang=ts"
export * from "./ChatMessagesList.vue?vue&type=script&lang=ts"

import "./ChatMessagesList.vue?vue&type=style&index=0&id=31d1b351&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d1b351"]])

export default __exports__